import { createReducer, on } from '@ngrx/store';
import { initialState } from './admin-products.state';
import * as AdminProductsActions from './admin-products.actions';

export const adminProductsReducer = createReducer(
  initialState,
  on(AdminProductsActions.loadAdminProducts, (state, { page }) => ({
    ...state,
    currentPage: page,
    isLoading: true,
    error: null
  })),
  on(AdminProductsActions.loadAdminProductsSuccess, (state, { productResponse }) => ({
    ...state,
    products: productResponse.content,
    totalElements: productResponse.totalElements,
    totalPages: productResponse.totalPages,
    isLoading: false
  })),
  on(AdminProductsActions.loadAdminProductsFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false
  }))
);
